/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Approval_AllowInputs */

const en_admin_ai_chat_approval_allow = /** @type {(inputs: Admin_Ai_Chat_Approval_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow`)
};

const de_admin_ai_chat_approval_allow = /** @type {(inputs: Admin_Ai_Chat_Approval_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erlauben`)
};

const es_admin_ai_chat_approval_allow = /** @type {(inputs: Admin_Ai_Chat_Approval_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permitir`)
};

const fr_admin_ai_chat_approval_allow = /** @type {(inputs: Admin_Ai_Chat_Approval_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autoriser`)
};

const nl_admin_ai_chat_approval_allow = /** @type {(inputs: Admin_Ai_Chat_Approval_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toestaan`)
};

/** @type {(inputs: Admin_Ai_Chat_Approval_AllowInputs) => LocalizedString} */
const it_admin_ai_chat_approval_allow = en_admin_ai_chat_approval_allow;

/** @type {(inputs: Admin_Ai_Chat_Approval_AllowInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_approval_allow = en_admin_ai_chat_approval_allow;

/** @type {(inputs: Admin_Ai_Chat_Approval_AllowInputs) => LocalizedString} */
const pl_admin_ai_chat_approval_allow = en_admin_ai_chat_approval_allow;

/** @type {(inputs: Admin_Ai_Chat_Approval_AllowInputs) => LocalizedString} */
const hu_admin_ai_chat_approval_allow = en_admin_ai_chat_approval_allow;

/** @type {(inputs: Admin_Ai_Chat_Approval_AllowInputs) => LocalizedString} */
const ro_admin_ai_chat_approval_allow = en_admin_ai_chat_approval_allow;

/**
* | output |
* | --- |
* | "Allow" |
*
* @param {Admin_Ai_Chat_Approval_AllowInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_approval_allow = /** @type {((inputs?: Admin_Ai_Chat_Approval_AllowInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Approval_AllowInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_approval_allow(inputs)
	if (locale === "de") return de_admin_ai_chat_approval_allow(inputs)
	if (locale === "es") return es_admin_ai_chat_approval_allow(inputs)
	if (locale === "fr") return fr_admin_ai_chat_approval_allow(inputs)
	if (locale === "nl") return nl_admin_ai_chat_approval_allow(inputs)
	if (locale === "it") return it_admin_ai_chat_approval_allow(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_approval_allow(inputs)
	if (locale === "pl") return pl_admin_ai_chat_approval_allow(inputs)
	if (locale === "hu") return hu_admin_ai_chat_approval_allow(inputs)
	return ro_admin_ai_chat_approval_allow(inputs)
});
export { admin_ai_chat_approval_allow as "admin.ai_chat.approval_allow" }